import React from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Link,
} from "@mui/material";
import {
  CloseRounded as CloseRoundedIcon
} from "@mui/icons-material";
import moment from "moment";
import { getComplexLocationLabel } from "../../../../utils/addressFields";

const initState = {
  isOpen: false,
  complexData: null,
}

class DialogComplexDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...initState
    };
  }

  open = ({ complexData }) => {

    this.setState({
      isOpen: true,
      complexData: complexData || null,
    });
  }

  close = () => {
    this.setState({
      ...initState
    })
  }

  formatDate = (date) => {
    if (!date) return 'Н/Д';
    if (typeof date === 'string' && /^\d{2}\.\d{2}\.\d{4}$/.test(date)) {
      return date;
    }
    return moment(date).format('DD.MM.YYYY');
  }
  renderField = (label, value, xs = 12, sm = 6) => (
    <Grid item xs={xs} sm={sm}>
      <Typography variant="body2" color="textSecondary">{label}</Typography>
      <Typography variant="body1" sx={{ mt: 0.5, fontWeight: 500 }}>
        {value || 'Н/Д'}
      </Typography>
    </Grid>
  )

  render() {
    const {
      isOpen,
      complexData,
    } = this.state;
    console.log('complexData: ', complexData)

    if (!isOpen) {
      return null
    }

    if (!complexData) {
      return (
        <Dialog
          open={isOpen}
          fullWidth={true}
          maxWidth="md"
          onClose={this.close}
        >
          <DialogTitle>
            <Grid container>
              <Grid item sx={{flex: 1}}>
                <Typography variant="h6">Подробная информация</Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={this.close}>
                  <CloseRoundedIcon/>
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography color="textSecondary">
                Нет данных
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={1} justifyContent="flex-end">
              <Grid item>
                <Button
                  size="small"
                  color="secondary"
                  variant="contained"
                  onClick={this.close}
                >Закрыть</Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      )
    }

    return (
      <Dialog
        open={isOpen}
        fullWidth={true}
        maxWidth="xl"
        onClose={this.close}
      >
        <DialogTitle>
          <Grid container justifyContent="space-between">
            <Grid item>
              Подробная информация
            </Grid>
            <Grid item>
              <IconButton onClick={this.close}>
                <CloseRoundedIcon/>
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Grid container spacing={3}>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Основная информация</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Серийный номер', complexData.complex_serial)}
                  {this.renderField('Модель', complexData.model)}
                  {this.renderField('Тип средства фиксации', complexData.class)}
                  {this.renderField('Подтип средства фиксации', complexData.subclass)}
                  {this.renderField('Дата изготовления', complexData.manufacture_date)}
                  {this.renderField('Страна производства', complexData.complex_country)}
                  {this.renderField('Производитель', complexData.complex_producer)}
                  {this.renderField('Количество видеокамер', complexData.cam_count)}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Местоположение и размещение</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Месторасположение', getComplexLocationLabel(complexData), 12)}
                  {this.renderField('Координаты комплекса',
                    (complexData.latitude_complex && complexData.longitude_complex)
                      ? `${complexData.latitude_complex}, ${complexData.longitude_complex}`
                      : null)}
                  {this.renderField('Регион РФ', complexData.region)}
                  {this.renderField('Значение автодороги', complexData.road_class)}
                  {this.renderField('Муниципальное образование', complexData.municipality)}
                  {this.renderField('Категория места расположения', complexData.location_cat)}
                  {this.renderField('Обоснование категории', complexData.location_cat_reason, 12)}
                  {this.renderField('ОКТМО', complexData.oktmo)}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Дорожные условия и зоны контроля</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Расстояние до знака 6.22', complexData.distance_622)}
                  {this.renderField('Расстояние до знака 5.23', complexData.distance_523)}
                  {this.renderField('Наличие общих зон контроля', complexData.shared_zones)}
                  {this.renderField('Расстояние до ближайшего средства', complexData.complex_distance)}
                  {this.renderField('Ширина зоны контроля', complexData.control_zone_width ? `${complexData.control_zone_width} м` : null)}
                  {this.renderField('Длина зоны контроля', complexData.control_zone_length ? `${complexData.control_zone_length} м` : null)}
                  {this.renderField('Количество контролируемых полос', complexData.control_zone_lanes)}
                </Grid>
              </Grid>
              <Grid size={12}><Divider/></Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Эксплуатационная информация</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Статус работы', complexData.commisioning_status)}
                  {this.renderField('Дата изменения статуса', this.formatDate(complexData.status_change_date))}
                  {this.renderField('Основание изменения статуса', complexData.status_change_reason, 12)}
                  {this.renderField('Дата ввода в Паутину', this.formatDate(complexData.starting_date))}
                  {this.renderField('Дата начала оказания услуг', this.formatDate(complexData.service_start))}

                  {this.renderField(
                    'Работоспособность',
                    complexData.online != null && complexData.online !== ''
                      ? (complexData.online ? 'Работает' : 'Не работает')
                      : null
                  )}
                  {this.renderField('Сведения о применении в Паутине', complexData.commisioning_info)}
                  {this.renderField('Дата письма ГИБДД', this.formatDate(complexData.commissioning_date))}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Разрешительная документация<br/>ИЗ СИСТЕМЫ УЧЕТА</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Номер свидетельства СИ', complexData.license_num)}
                  {this.renderField('Начало действия свидетельства', this.formatDate(complexData.license_start_date))}
                  {this.renderField('Окончание действия свидетельства', this.formatDate(complexData.license_end_date))}
                  {this.renderField('Номер поверки', complexData.verification_num)}
                  {this.renderField('Дата очередной поверки', this.formatDate(complexData.verification_outdata))}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Разрешительная документация<br/>ИЗ ФГИС "Аршин"</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {complexData.certificate_arshin ? (
                    <>
                      {this.renderField('Номер свидетельства СИ', complexData.certificate_arshin.mit_number)}
                      {this.renderField('Начало действия свидетельства', this.formatDate(complexData.certificate_arshin.verification_date))}
                      {this.renderField('Окончание действия свидетельства', this.formatDate(complexData.certificate_arshin.valid_date))}
                      {this.renderField('Номер поверки', complexData.certificate_arshin.result_docnum)}
                      {this.renderField('Дата очередной поверки', this.formatDate(complexData.certificate_arshin.valid_date))}
                      {complexData.certificate_arshin.certification_url && (
                        <Grid item xs={12}>
                          <Typography variant="body2" color="textSecondary">Ссылка</Typography>
                          <Link
                            href={complexData.certificate_arshin.certification_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ mt: 0.5, display: 'inline-block', fontWeight: 500 }}
                          >
                            Ссылка
                          </Link>
                        </Grid>
                      )}
                    </>
                  ) : (
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">Нет данных</Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid size={12}><Divider/></Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Владельцы и обслуживание</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Собственник', complexData.owner)}
                  {this.renderField('Обслуживающая организация', complexData.servorg)}
                  {this.renderField('Согласование с владельцем', complexData.owner_alignment_doc)}
                  {this.renderField('Дата согласования', this.formatDate(complexData.owner_alignment_date))}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Интеграция с ГИБДД</Typography>
                <Grid container spacing={2} flexDirection="column">
                  {this.renderField('Место расположения в приказе', complexData.location_gibdd || 'тот же')}
                  {this.renderField('Основание изменения адреса', complexData.location_change_reason)}
                </Grid>
              </Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Демонтаж</Typography>
                <Grid container spacing={2} flexDirection="column">
                  {this.renderField('Год демонтажа', this.formatDate(complexData.demontage_date || ''))}
                  {this.renderField('Причина демонтажа', complexData.demontage_reason)}
                </Grid>
              </Grid>
              <Grid size={12}><Divider/></Grid>
              <Grid size={4}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Финансовая информация</Typography>
                <Grid container spacing={1} flexDirection="column">
                  {this.renderField('Стоимость СМР', complexData.smr_price ? `${complexData.smr_price} тысяч рублей` : null)}
                  {this.renderField('Признак национального проекта', complexData.bkd || 'Не БКД')}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Button
                size="small"
                color="secondary"
                variant="contained"
                onClick={this.close}
              >Закрыть</Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DialogComplexDetails
